import styled from 'styled-components';

import Button from '@components/Button/next';

export const ResponsiveSearchSubmitButtonWrapper = styled.div<{
  positionControl?: boolean;
}>`
  grid-row: 3/4;
  width: 100%;
  padding: 10px 15px;
  display: flex;
  align-items: center;

  position: ${({ positionControl }) =>
    positionControl ? 'relative' : 'absolute'};
  bottom: 0px;
  right: 0px;
  background-color: ${({ positionControl, theme }) =>
    positionControl ? 'rgba(58, 58, 58, 0.2)' : theme.palette.white};
  z-index: 10;
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  width: 100% !important;
  display: block;
  font-weight: bold;
  font-size: 14px !important;
  border-radius: 8px;
`;
